import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_NEXT_PAYMENT: MijnRoute = {
    path: 'volgende-afschrijving',
    navigationEvent: 'toVolgendeHypotheekAfschrijving',
    regex: /^\/hypotheek\/volgende-afschrijving$/,
    webcomponent: 'mijn-hypotheken-home-webcomponent',
    internalPath: '/volgende-afschrijving'
};
